import styled from 'styled-components';
import { IconButton } from '@mui/material';

const ApplicationActionsContainer = styled.div`
	display: flex;
	gap: 5px;
`;

const EllipsisButton = styled(IconButton)`
	width: 2rem;
	height: 2rem;
	display: flex;
`;

export default {
	ApplicationActionsContainer,
	EllipsisButton
};
